module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input-base', {
    ref: "input",
    attrs: {
      "type": _vm.type,
      "value": _vm.value,
      "label": _vm.label,
      "help": _vm.help,
      "error": _vm.error
    },
    on: {
      "input": _vm.inputted,
      "change": _vm.changed,
      "blur": _vm.blurred,
      "focus": _vm.focused,
      "click": _vm.clicked
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-08e1ea65", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-08e1ea65!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/common/InputLabelled.vue
// module id = 815
// module chunks = 0